/**
 * Gate a route on one of the organization's visibility settings.
 *
 * The same shape and the same disclaimer as `RequireRole`: presentation, so a
 * person is sent to an explanation instead of a failure, and the callables
 * behind the page refuse the work regardless of what renders. It exists
 * because a role floor written into the route table cannot answer a question
 * the organization gets to decide: an organization that opens acknowledgement
 * reports to Approvers would otherwise have the server serve them and the
 * router send them to "not authorized".
 *
 * Nothing renders until the settings are known, so the page cannot flash and
 * redirect somebody who is in fact allowed.
 */

import { Navigate } from 'react-router-dom';
import { useVisible, type Visible } from '../features/org/useVisibility';

type VisibilityKey = Exclude<keyof Visible, 'known'>;

export function RequireVisibility({
  setting,
  children,
}: {
  setting: VisibilityKey;
  children: React.ReactNode;
}) {
  const visible = useVisible();
  if (!visible.known) return null;
  if (!visible[setting]) return <Navigate to="/not-authorized" replace />;
  return <>{children}</>;
}
